import { render, staticRenderFns } from "./Timnas.vue?vue&type=template&id=0a81392e&"
import script from "./Timnas.vue?vue&type=script&lang=js&"
export * from "./Timnas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports